function getPath() {
  let environment = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'staging';
  let hosts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    prod: 'www.autotrader.com',
    staging: 'test.autotrader.com'
  };
  // default to 'staging' when invalid environment value is passed
  const path = hosts[environment] || hosts.staging || '';
  return `https://${path}/`;
}
export { getPath as default };
